import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const MissionVision = () => {
  return (
    <section id="mission" className="py-20 md:py-28 rc-section-soft">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-2 gap-10 md:gap-14">
          {/* Mission */}
          <div className="bg-white rounded-2xl border border-[hsl(var(--border))] p-8 md:p-10 rc-card-hover">
            <div className="flex items-center gap-3">
              <span className="w-8 h-px bg-[hsl(var(--rc-gold))]" />
              <p className="text-[12px] tracking-[0.2em] uppercase text-[hsl(var(--rc-purple))] font-medium">
                Our Mission
              </p>
            </div>
            <h3 className="font-serif-display mt-5 text-[30px] md:text-[36px] leading-[1.15] font-semibold text-[hsl(var(--rc-deep))]">
              Empowering recovery through personalized, peer-led guidance.
            </h3>
            <p className="mt-5 text-[15.5px] leading-[1.75] text-[hsl(var(--rc-slate))]">
              We are a team of Certified Recovery Peer Specialists providing
              compassionate support and connecting individuals and families to
              essential resources — offering multiple pathways to long-term,
              sustainable recovery.
            </p>
            <Link
              to="/about"
              className="mt-7 inline-flex items-center gap-2 text-[14px] font-semibold text-[hsl(var(--rc-purple))] hover:text-[hsl(var(--rc-deep))] transition-colors group"
            >
              Read more about our mission
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>

          {/* Vision */}
          <div className="bg-[hsl(var(--rc-deep))] text-white rounded-2xl p-8 md:p-10 relative overflow-hidden">
            <div
              aria-hidden
              className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[hsl(var(--rc-purple))]/40 blur-3xl"
            />
            <div className="relative">
              <div className="flex items-center gap-3">
                <span className="w-8 h-px bg-[hsl(var(--rc-gold))]" />
                <p className="text-[12px] tracking-[0.2em] uppercase text-[hsl(var(--rc-gold))] font-medium">
                  Our Vision
                </p>
              </div>
              <h3 className="font-serif-display mt-5 text-[30px] md:text-[36px] leading-[1.15] font-semibold">
                A Central Florida where every person seeking recovery has
                access to the support they need.
              </h3>
              <p className="mt-5 text-[15.5px] leading-[1.75] text-white/80">
                We envision a community where peer-led recovery support is
                accessible, respected, and embedded across the systems people
                rely on — from healthcare to housing to the workplace.
              </p>
              <div className="mt-9 flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center">
                  <span className="font-serif-display text-[20px] text-[hsl(var(--rc-gold))]">
                    “
                  </span>
                </div>
                <p className="text-[13.5px] italic text-white/85 max-w-sm">
                  Recovery is possible. Connection makes it sustainable.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;
